import { CarvanaTheme } from '@carvana/theme';
import styled from 'styled-components';

export const MapWrapper = styled.div`
  & {
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2em;
    margin-bottom: 60px;

    @media (min-width: 768px) {
      width: 100%;
    }
  }
`;

export const MapOuterContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
`;

export const MapInnerContainer = styled.div`
  max-height: 683px;
  min-height: 683px;
  width: 100%;
  position: relative;
  overflow-y: hidden;

  // ensure some size for intersection observer
  & > div {
    min-height: 1px;
    min-width: 1px;
  }

  @media (min-width: ${CarvanaTheme.breakpoints.values.lg}px) {
    max-height: 956px;
    min-height: 956px;
  }
`;

export const mapContainerStyle = {
  height: '956px',
  width: '100%',
  top: 0,
  position: 'absolute' as const
};
